<template>
  <div class="bem-vindo-container">
    <h3 class="secondary-font text--secondary text-center py-8">
      Avaliação Psicossocial
    </h3>
    <v-row no-gutters justify="center" align="center" class="h-100">
      <v-col cols="10" sm="7" md="6" lg="5" class="text-center">
        <h2 class="secondary-font">Bem-vindo(a) {{ nome }}!</h2>

        <div v-if="loadingCheck" class="mt-10">
          <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
          <h4 class="mt-4 text--secondary">Validando seu acesso...</h4>
        </div>

        <div v-else-if="errorMessage" class="mt-10">
          <v-icon size="80" color="error" class="mb-6">mdi-lock-alert</v-icon>

          <h3 class="error--text font-weight-bold px-4">
            {{ errorMessage }}
          </h3>

          <h5 class="text--secondary mt-4 px-4">
            Não é possível prosseguir com a avaliação.
          </h5>

          <div class="mt-10 d-flex flex-column align-center">
            <v-btn
              to="/psicossocial"
              color="primary"
              class="secondary-font text-none font-weight-bold mb-6"
              elevation="2"
              rounded
              large
            >
              Meus Mapeamentos
            </v-btn>

            <v-btn
              :to="onCancelRoute"
              color="error"
              class="secondary-font text-capitalize font-weight-black px-8"
              outlined
              rounded
              large
            >
              Voltar
            </v-btn>
          </div>
        </div>

        <div v-else>
          <h4 class="secondary-font text--secondary mt-5">
            Olá! Esta é a sua Avaliação Psicossocial. Queremos saber como você está para podermos cuidar melhor de você
            e de todo o nosso time. Sinta-se à vontade para responder com sinceridade: tudo aqui é 100% confidencial e
            anônimo. Nossa meta é construir, juntos, um ambiente de trabalho cada vez mais saudável e leve.
          </h4>
          <h6 class="secondary-font text--secondary mt-5">
            <i>Obs.: Use um local tranquilo e reserve de 5 a 10 minutos para preencher esta avaliação</i>
          </h6>

          <v-row no-gutters justify="center" align="center" class="mt-7">
            <v-col cols="12" sm="8" md="8" lg="8">
              <v-btn
                @click="onClick"
                color="primary"
                class="secondary-font text-capitalize font-weight-black mb-4"
                elevation="24"
                rounded
                block
                large
              >
                Continuar
                <v-icon right>mdi-arrow-right-bold-circle-outline</v-icon>
              </v-btn>

              <v-btn
                :to="onCancelRoute"
                color="error"
                class="secondary-font text-capitalize font-weight-black"
                text
                rounded
              >
                Cancelar
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="modalRepreenchimento" persistent max-width="500">
      <v-card style="border-radius: 14px;">
        <v-card-text class="pt-6 text-center text-body-1 font-weight-medium text--primary">
          Você já preencheu esse mapeamento. A tentativa de repreenchimento anulará a resposta anterior. Os seus dados
          já foram computados. Deseja mesmo assim fazer o repreenchimento?
        </v-card-text>

        <v-card-actions class="px-6 pb-6 d-flex justify-space-between">
          <v-btn color="grey" class="white--text px-6" elevation="0" rounded @click="modalRepreenchimento = false">
            Sim
          </v-btn>

          <v-btn color="success" class="px-6" elevation="2" rounded to="/psicossocial">
            Não
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  props: {
    onCancelRoute: {
      default: '/dashboard'
    }
  },
  data: () => ({
    loadingCheck: true,
    errorMessage: '',
    modalRepreenchimento: false
  }),
  computed: {
    ...mapState('user', ['nome', 'idEmpresaFuncionario']),
    ...mapState('avaliacaoPsicossocial', ['mapeamentoPsicossocial'])
  },
  methods: {
    ...mapActions('avaliacaoPsicossocial', ['preparaAvaliacaoPsicossocial']),
    ...mapActions('avaliacaoPsicossocial', ['setMapeamentoPsicossocial']),

    onClick() {
      this.$router.push('/avaliacao-psicossocial/perguntas')
    }
  },
  async mounted() {
    this.loadingCheck = true
    this.errorMessage = ''

    try {
      const query = this.$route.query

      if (query && query.token) {
        await this.setMapeamentoPsicossocial({ token: query.token })
      } else if (query && query.encryptedIdMapeamento) {
        await this.setMapeamentoPsicossocial({
          encryptedIdMapeamento: query.encryptedIdMapeamento,
          encryptedIdsEmpresas: query.encryptedIdsEmpresas
        })
      }

      const response = await this.preparaAvaliacaoPsicossocial(this.idEmpresaFuncionario)

      if (response && response.jaPreenchido) {
        this.modalRepreenchimento = true
      }
    } catch (error) {
      console.error('Erro de validação:', error)
      this.errorMessage = error.response?.data?.message || 'Erro ao validar acesso.'
    } finally {
      this.loadingCheck = false
    }
  }
}
</script>

<style scoped>
.bem-vindo-container {
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
}

.h-100 {
  flex: 1;
}
</style>
